import { UniDriver } from '@wix/unidriver-core';

import { buttonCoreDriverFactory } from './ButtonCore/ButtonCore.uni.driver';
import { baseUniDriverFactory } from '../utils/test-utils/unidriver';
import { ButtonSkin } from './Button.types';

export const buttonDriverFactory = (base: UniDriver) => {
  const buttonCoreDriver = buttonCoreDriverFactory(base);

  return {
    ...baseUniDriverFactory(base),

    // Gets button text
    getButtonTextContent: buttonCoreDriver.getButtonTextContent,

    // Checks whether button is focused
    isFocused: buttonCoreDriver.isFocused,

    // Checks whether button is disabled
    isButtonDisabled: buttonCoreDriver.isButtonDisabled,

    // Checks whether button has a given skin
    hasSkin: async (skinName: ButtonSkin) =>
      (await base.attr(`data-skin`)) === skinName,

    /**
     * Checks whether button has an icon prefix
     * @return {Promise<boolean>}
     */
    isPrefixIconExists: buttonCoreDriver.isPrefixIconExists,

    // Checks whether button has an icon suffix
    isSuffixIconExists: buttonCoreDriver.isSuffixIconExists,
  };
};

export type ButtonUniDriver = ReturnType<typeof buttonDriverFactory>;
